<template>
  <el-dialog title="铺货价格预览"
    :append-to-selector="extendProps.source == 'batchCheckPdd' ?'body':''"
    :modal-append-to-selector="extendProps.source == 'batchCheckPdd' ?'body':''"
   :visible.sync="dialogVisible" width="900px" :close="handleClose">
    <el-tabs v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane label="铺货价格（通用）" name="common"></el-tab-pane>
      <el-tab-pane label="铺货价格（店铺）" name="shops"></el-tab-pane>
    </el-tabs>
    <div v-if="activeName === 'shops' && !priceConfShopList.length" style="color: red">
      暂无店铺价格策略，如店铺需配置独立铺货价格策略， 可前往
      <el-link @click="toPlatformConf"> {{ platformPriceNames.name }}铺货配置</el-link> 配置
    </div>
    <div v-else>
      <div v-if="activeName === 'shops'">
        店铺名称：
        <el-select v-model="chooseShopId" placeholder="请选择" width="200px" @change="changeShop">
          <el-option v-for="item in priceConfShopList" :key="item.shopId" :label="item.shopName" :value="item.shopId"> </el-option>
        </el-select>
        <el-divider style="margin: 10px"></el-divider>
      </div>
      <PriceConfig :priceRule="priceRule.sales" />
      <template v-if="priceRule.market">
        <el-divider style="margin: 10px"></el-divider>
        <PriceConfig :priceRule="priceRule.market" />
      </template>
      <el-divider style="margin: 10px"></el-divider>
      <div class="sku-batch-row" v-if="specificationNames && specificationNames.length > 0">
        <template v-for="(sname, sindex) in specificationNames">
          <div class="sku-batch-item" :key="sname + sindex">
            <div class="sku-batch-item_label">{{ sname }}：</div>
            <el-select
              style="width: 120px"
              placeholder="全部"
              multiple
              collapse-tags
              clearable
              v-model="skuBatchUpdateForm[sname]"
              @change="getRenderList"
            >
              <el-option
                v-for="(value, vindex) in specificationsValues[sname]"
                :key="sname + sindex + value + vindex"
                :label="value"
                :value="value"
              >
              </el-option>
            </el-select>
          </div>
        </template>
      </div>
      <div v-if="!['batchCheckFxg','batchCheckKs','batchCheckWxsph'].includes(extendProps.source)" class="sku-batch-item">
        <el-button type="primary" @click="skuBatch('skuShowPrice')">{{
          opts.platform === 'pdd' ? '批量设置拼单价' : '批量设置价格'
        }}</el-button>
        <el-button v-if="opts.platform === 'pdd'" type="primary" @click="skuBatch('skuShowMultiPrice')">批量设置单买价</el-button>
        <el-button v-if="!['batchCheckPdd','batchCheckTb'].includes(extendProps.source)" type="primary" @click="skuBatch('stock')">批量设置库存</el-button>
      </div>
      <div class="price-list">
        <el-table-grid height="300px" :data="renderList" @selection-change="handleSelectionChange">
          <el-table-column width="60px" type="selection"></el-table-column>
          <template v-for="(sname, index) in specificationNames">
            <el-table-column :key="sname + index" :label="sname" width="140">
              <template slot-scope="{ row }">
                {{ row.skuNameMap[sname] || '' }}
              </template>
            </el-table-column>
          </template>
          <template v-for="col in cols">
            <el-table-column v-if="col.visible" :key="col.prop" :prop="col.prop" v-bind="col.attrs">
              <template slot-scope="{ row }">
                <template v-if="col.input && col.input.type === 'number'">
                  <el-input-digit
                    :className="checkPrice(row, col.prop) ? 'dangerText' : ''"
                    v-model.number="row[col.prop]"
                    :nullable="true"
                    :disabled="col.disabledFn ? col.disabledFn(row) : false"
                  />
                </template>
                <template v-else>
                  {{ col.format ? col.format(row) : row[col.prop] }}
                </template>
              </template>
            </el-table-column>
          </template>
        </el-table-grid>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleOK">确 定</el-button>
    </span>
    <EditPriceDialog ref="editPriceDialogRef" />
    <EditStockDialog ref="editStockDialogRef" />
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex"
import { getControllerPriceList } from '@/api/prod/center';
import { getPriceName } from '@/dictionary/price';
import EditPriceDialog from './EditPriceDialog.vue';
import EditStockDialog from './EditStockDialog.vue';
import PriceConfig from './PriceConfig.vue';
import { cloneDeep } from 'lodash';
export default {
  components: { EditPriceDialog, EditStockDialog, PriceConfig },
  props: {
    extendProps: {
      type: Object,
      default(){
        return {
          source:'',//batchCheckFxg: 表示来自批量铺货校验抖音，batchCheckPdd，来自于批量校验拼多多
        }
      }
    }
  },
  data() {
    return {
      activeName: 'common',
      dialogVisible: false,
      opts: {},
      orignPriceData: {},
      getPriceName,
      platformPriceNames: {},
      priceConfShopList: [],
      curList: [],
      renderList: [],
      selectList: [],
      chooseShopId: '',
      priceData: {},
      specificationNames: [],
      specificationsValues: [],
      skuBatchUpdateForm: {},
    };
  },
  computed: {
    ...mapGetters(['isDistributor']),
    cols() {
      let isShowSupplyFreightPrice = this.isDistributor && !!this.opts?.isDistribution && !!this.priceRule?.sales?.isCalculateFreight; // 分销商角色 && 分销商品 && 勾选了供销运费配置
      let skuShowPriceLabel = {
        batchCheckPdd:isShowSupplyFreightPrice ? '拼单价（含附加供销运费）' : '拼单价（元）',
        batchCheckWxsph:isShowSupplyFreightPrice ? '售价（含附加供销运费）' : '售价',
        batchCheckXhs:isShowSupplyFreightPrice ? '售价（含附加供销运费）' : '售价',
        batchCheckJd:isShowSupplyFreightPrice ? '京东价（含附加供销运费）' : '京东价（元）',
      }
      let isShowStock = !["batchCheckFxg","batchCheckPdd","batchCheckTb","batchCheckKs","batchCheckWxsph","batchCheckJd"].includes(this.extendProps.source)
      const colList = [
        { prop: 'purchasePrice', attrs: { label: '供货价（元）', width: 100 }, visible: this.opts.isDistribution },
        {
          prop: 'controlPrice',
          attrs: { label: '分销控价（元）', width: 120 },
          visible: this.opts.isDistribution,
          format: this.getControlPriceText,
        },
        { prop: 'purchasePrice', attrs: { label: '成本价（元）', width: 100 }, visible: !this.opts.isDistribution },
        {
          prop: 'skuFreightPrice',
          attrs: { label: '附加供销运费', width: 100 },
          input: null,
          formatter: null,
          visible: isShowSupplyFreightPrice,
        },
        {
          prop: 'skuShowPrice',
          attrs: { label: skuShowPriceLabel[this.extendProps.source] || `价格${isShowSupplyFreightPrice ? '（含附加供销运费）': '（元）'}`, width: 160 },
          input: ['batchCheckFxg','batchCheckKs','batchCheckJd'].includes(this.extendProps.source) ? null : { type: 'number' },
          formatter: this.extendProps.source === "batchCheckFxg" ? (row) => row.skuShowPrice : null,
          visible: true,
        },
        {
          prop: 'skuShowMultiPrice',
          attrs: { label: '单买价（元）', width: 100 },
          input: { type: 'number' },
          visible: this.opts.platform === 'pdd' ? true : false,
        },
        { 
          prop: 'stock', 
          attrs: { label: '库存', width: 100 }, 
          input: { type: 'number' }, 
          visible: isShowStock
        },
      ];
      return colList;
    },
    priceRule() {
      const { price, shopPriceConf } = this.orignPriceData || {};
      let priceConfRule = [];
      if (this.activeName === 'shops') {
        let shopPriceConfList = shopPriceConf ? JSON.parse(shopPriceConf) : [];
        const shopRule = shopPriceConfList.find(item => item.shopIds.includes(this.chooseShopId));
        if (shopRule) {
          priceConfRule = shopRule.confList;
        }
      } else {
        priceConfRule = price ? JSON.parse(price) : [];
      }
      if (!priceConfRule?.length) return { sales: {}, market: null };
      const getRuleConf = type => {
        let rule = priceConfRule.find(item => item.type === type) || {};
        const { formulaValue = {}, way,isCalculateFreight,supplyFormulaValue } = rule;
        const platFormPriceConfig = this.platformPriceNames;

        rule.platFormPriceConfig = platFormPriceConfig
        rule.priceConfText =
          way === 'formula' ? this.getFormulaText(rule) : `取${platFormPriceConfig.name}资料保存的${platFormPriceConfig[type]}`;
        if(!!this.opts?.isDistribution && !!isCalculateFreight){
          rule.supplyFreight = `供销运费 X ${supplyFormulaValue.percentage}% + ${supplyFormulaValue.addValue}元 - ${supplyFormulaValue.subtractionValue}元`
        }
        return rule;
      };
      return {
        sales: getRuleConf('sales'),
        market: this.opts.platform === 'pdd' ? getRuleConf('market') : null,
      };
    },
  },
  watch: {
    renderList: {
      handler(ls) {
        // 更新curList
        ls.forEach(renderItem => {
          const index = this.curList.findIndex(item => item.skuId === renderItem.skuId);
          if (index !== -1) {
            this.curList[index] = cloneDeep(renderItem);
          }
        });

        // 确定目标数据位置
        const { commonSkuInfo, tmCommonSkuInfos, shopSkuInfos } = this.priceData;
        let target =
          this.activeName === 'shops' ? shopSkuInfos?.[this.chooseShopId] : this.opts.platform === 'tm' ? tmCommonSkuInfos : commonSkuInfo;

        // 更新目标数据
        if (target) {
          target.skuInfoList = cloneDeep(this.curList);
        }
      },
      deep: true,
    },
  },
  methods: {
    toPlatformConf() {
      const isDistributor = this.$store.getters.userInfo.loginIdentity == '2';
      const routeData = this.$router.resolve({
        path: isDistributor ? '/distributor/prod_conf' : '/supplier/prod_conf',
        query: { tabName: 'distribution', platform: this.opts.platform, platformName: this.platformPriceNames.name },
      });
      window.open(routeData.href, '_blank', 'noopener,noreferrer')
      this.opts?.cancelFn()
    },
    getFormulaText(rule) {
      const { percentage = 0, addValue = 0, subtractionValue = 0, priceMultiplier } = rule.formulaValue;
      return `${this.getPriceTypeName(rule.type, priceMultiplier)} X 资料保存的${percentage}% + ${addValue}元 - ${subtractionValue} 元`;
    },
    async getControllerPriceData() {
      try {
        const { baseItemIds, shopList, platform, flowNumber } = this.opts;
        const params = {
          itemId: baseItemIds[0],
          shopIds: shopList.map(shop => shop.shopId),
          platformType: platform,
          isDistribution:+this.isDistributor,
        }
        if(["batchCheckFxg","batchCheckPdd","batchCheckTb","batchCheckXhs"].includes(this.extendProps.source)){
          // 批量铺货新增参数
          params.flowNumber = flowNumber
        }
        const res = await getControllerPriceList(params);
        const priceData = res.data || {};
        this.priceData = cloneDeep(priceData);
        this.orignPriceData = cloneDeep(priceData);

        // 使用flatMap和Set简化店铺ID收集
        const shopPriceConf = priceData.shopPriceConf ? JSON.parse(priceData.shopPriceConf) : [];
        const priceConfShopIds = [...new Set(shopPriceConf.flatMap(item => item.shopIds))];

        // 直接赋值过滤后的店铺列表
        this.priceConfShopList = priceConfShopIds.map(id => this.opts.shopList.find(shop => shop.shopId === id)).filter(Boolean);
      } catch (error) {
        console.error('获取价格数据失败:', error);
        // 可以添加错误提示或默认值设置
        this.priceData = {};
        this.priceConfShopList = [];
      }
    },
    processPriceData() {
      const { commonSkuInfo, tmCommonSkuInfos, shopSkuInfos } = this.priceData;
      let curInfo = commonSkuInfo;
      if (this.opts.platform === 'tm') {
        curInfo = tmCommonSkuInfos;
      }
      if (this.activeName === 'shops' && shopSkuInfos && shopSkuInfos[this.chooseShopId]) {
        curInfo = shopSkuInfos[this.chooseShopId];
      }
      if (!curInfo) return;
      const { skuNameList = [], skuInfoList = [] } = curInfo;
      this.curList = cloneDeep(skuInfoList);
      this.specificationNames = skuNameList;

      this.specificationsValues = skuNameList.reduce((acc, sname) => {
        this.skuBatchUpdateForm[sname] = [];
        acc[sname] = [...new Set(skuInfoList.map(item => item.skuNameMap[sname] || ''))];
        return acc;
      }, {});
      this.getRenderList();
    },
    handleTabClick(tab) {
      if (this.activeName === 'shops' && this.priceConfShopList.length && !this.chooseShopId) {
        this.chooseShopId = this.priceConfShopList[0].shopId;
      }
      this.processPriceData();
    },
    changeShop(v) {
      this.processPriceData();
    },
    // 批量设置
    skuBatch(btnName) {
      const { selectList } = this;
      if (!selectList?.length) {
        return this.$message.warning('请先选择数据！');
      }

      const dialogRefMap = {
        skuShowPrice: 'editPriceDialogRef',
        skuShowMultiPrice: 'editPriceDialogRef',
        stock: 'editStockDialogRef',
      };

      const dialogRef = this.$refs[dialogRefMap[btnName]];
      if (!dialogRef) return;
      if (['skuShowPrice', 'skuShowMultiPrice'].includes(btnName)) {
        dialogRef.method_open({
          type:  btnName === 'skuShowMultiPrice' ? 'market' : 'sales',
          baseItemId: this.opts.baseItemIds[0],
          platformType: this.opts.platform,
          shopId: this.chooseShopId,
          shopIds: this.opts.shopList.map(shop => shop.shopId),
          activeName: this.activeName,
          okFn: (way, data) => {
            if (way === 'unity') {
              this.setListNum(btnName, data);
            } else {
              const { commonSkuInfo, tmCommonSkuInfos, shopSkuInfos } = data;
              let target =
                this.activeName === 'shops'
                  ? shopSkuInfos?.[this.chooseShopId]
                  : this.opts.platform === 'tm'
                  ? tmCommonSkuInfos
                  : commonSkuInfo;
              // 更新目标数据
              if (!target?.skuInfoList?.length) return;

              this.renderList.forEach(item => {
                if (this.selectList.some(selectItem => selectItem.skuId === item.skuId)) {
                  const findItem = target.skuInfoList.find(sku => item.skuId === sku.skuId);
                  if (findItem) {
                    item[btnName] = findItem[btnName];
                  }
                }
              });
            }
          },
        });
      } else if (btnName === 'stock') {
        dialogRef.method_open({
          okFn: num => this.setListNum(btnName, num),
        });
      }
    },
    setListNum(btnName, num) {
      const selectList = this.selectList;
      this.renderList.forEach(item => {
        if (selectList.some(selectItem => selectItem.skuId === item.skuId)) {
          item[btnName] = num;
        }
      });
    },
    handleSelectionChange(select) {
      this.selectList = select;
    },

    async method_open(opts = {}) {
      this.dialogVisible = true;
      this.opts = { type: 'sales', ...opts };
      this.platformPriceNames = this.getPriceName(this.opts.platform);
      await this.getControllerPriceData();
      this.processPriceData();
    },
    handleClose() {
      Object.assign(this.$data, this.$options.data());
      this.dialogVisible = false;
    },
    handleOK() {
      const { commonSkuInfo, shopSkuInfos, tmCommonSkuInfos } = cloneDeep(this.priceData);

      // 提取通用SKU配置
      const getSkuConfig = sku => ({
        skuId: sku.skuId,
        skuPrice: sku.skuShowPrice,
        skuMarketPrice: sku.skuShowMultiPrice,
        skuNum: sku.stock,
      });

      // 处理通用SKU配置
      let commonSkuList = this.opts.platform === 'tm' ? tmCommonSkuInfos?.skuInfoList : commonSkuInfo?.skuInfoList;
      const commonSkuInfoConfigs = commonSkuList?.map(getSkuConfig) || [];

      // 处理店铺SKU配置
      const shopSkuInfoConfigs = {};
      this.priceConfShopList.forEach(shop => {
        const skuInfoList = shopSkuInfos?.[shop.shopId]?.skuInfoList || [];
        shopSkuInfoConfigs[shop.shopId] = skuInfoList.map(getSkuConfig);
      });

      if(this.extendProps.source === 'batchCheckTb'){
        this.opts.okFn?.({
          priceData: commonSkuInfoConfigs,
          baseItemIds: this.opts.baseItemIds,
        });
      }else if(['batchCheckPdd','batchCheckXhs'].includes(this.extendProps.source)){
        this.opts.okFn?.({
          priceData: this.priceData,
          baseItemId: this.opts.baseItemIds[0],
        });
      } else if(this.extendProps.source === 'batchCheckWxsph'){
        this.opts.okFn?.({
          priceData: commonSkuInfoConfigs,
          baseItemIds: this.opts.baseItemIds,
        });
      }else{
        this.opts.okFn?.({
          shopSkuInfoConfigs,
          publishCommonConfigs: { skuInfoConfigs: commonSkuInfoConfigs },
        });
      }
      this.handleClose();
    },
    getRenderList() {
      const renderList = this.curList.filter(item => {
        const matched = this.specificationNames.every(
          sname => !this.skuBatchUpdateForm[sname]?.length || this.skuBatchUpdateForm[sname].includes(item.skuNameMap[sname])
        );
        return matched;
      });
      this.renderList = renderList;
      return renderList;
    },
    checkPrice(item, prop) {
      if(!['skuShowPrice', 'skuShowMultiPrice'].includes(prop)) return false
      const { controllerMinPrice, controllerMaxPrice } = item;
      if (!item[prop]) return false;
      // 价格低于最低控制价
      if (controllerMinPrice && item[prop] < controllerMinPrice) return true;
      // 价格高于最高控制价
      if (controllerMaxPrice && item[prop] > controllerMaxPrice) return true;

      return false;
    },
    getControlPriceText(item) {
      if (item.controllerMinPrice && item.controllerMaxPrice) {
        return `${item.controllerMinPrice}元 ~ ${item.controllerMaxPrice}元`;
      } else if (item.controllerMinPrice && !item.controllerMaxPrice) {
        return `不低于${item.controllerMinPrice} 元`;
      } else if (!item.controllerMinPrice && item.controllerMaxPrice) {
        return `不高于${item.controllerMaxPrice}元`;
      } else {
        return '—';
      }
    },

    // 获取配置价格的展示方式
    getPriceTypeName(type, priceMultiplier) {
      const platFormPriceConfig = this.platformPriceNames;
      const priceMap = new Map([
        ['now', platFormPriceConfig.name + platFormPriceConfig[type]],
        ['pdd_multi_price', '拼多多拼单价'],
        ['base_sales', '基础资料销售价'],
        ['base_market', '基础资料市场价'],
        ['base_purchase', '基础资料成本价'],
        ['base_base_selling', '基础资料基本售价'],
      ]);
      return priceMap.get(priceMultiplier) || '基础资料销售价';
    },
  },
};
</script>

<style lang="scss" scoped>
.el-divider--horizontal {
  margin: 10px 0;
}
.price-list {
  ::v-deep .dangerText {
    color: red;
  }
}
.sku-batch-row {
  display: flex;
  flex-wrap: wrap;
  &:first-of-type {
    margin-top: 8px;
  }
}
.sku-batch-item {
  display: flex;
  margin-bottom: 8px;
  margin-right: 8px;
  .sku-batch-item_label {
    min-width: 80px;
    max-width: 100px;
    text-align: right;
  }
}
</style>
